module.exports = __webpack_public_path__ + "img/L_6H.03eb5fe3.png";